const SMTP_CREDENTIALS = {
  host: "smtp.office365.com",
  user: "gnsmtp@gnonline.onmicrosoft.com",
  pass: "PASS",
  from: "feedback@gulfnews.com",
};

const RECAPTCHA_SECRET_KEY = "KEY";

module.exports = { SMTP_CREDENTIALS, RECAPTCHA_SECRET_KEY };
